module.exports = __webpack_public_path__ + "static/media/img-gold@2x.d3287362.jpg";